<template>
	<div class="searchresult">
		
		<div class="search_resu" v-if="!no_list">
			<!-- <div class="result_title">最新消息</div>
			<div class="result_box">
				<van-row class="result_box_title">
					<van-col span="6">推送时间</van-col>
					<van-col span="18">预警内容</van-col>
				</van-row>
				<van-row v-for="(item,index) in list" :key="'list_' + item.id" :class="index % 2==0?'result_text result_text_active':'result_text'">
					<van-col span="6">{{item.create_time}}</van-col>
					<van-col style="text-decoration:underline;" span="18" @click="goWaringInfo(item.id,index)">{{item.keyword}}</van-col>
				</van-row>
			</div> -->
			<!-- <div class="result_title">2021/02/01</div> -->
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list
				v-model="loading"
				:finished="finished"
				finished-text="已加载全部"
				@load="onLoad"
				>
				<div v-for="(item,index) in list" :key="'list_' + item.id" :class="item.is_read==0?'result_box':'result_box c-gray'">
					<van-row class="result_box_title">
						<van-col span="6">推送时间</van-col>
						<van-col span="11">预警内容</van-col>
						<van-col span="4">舆情级别</van-col>
						<van-col span="3">状态</van-col>
					</van-row>
					<van-row class="result_text result_text_active">
						<van-col span="6" @click="goWaringInfo(item.id,index)">{{item.create_time}}</van-col>
						<van-col style="text-decoration:underline;" span="11" @click="goWaringInfo(item.id,index)">{{item.keyword}}</van-col>
						<van-col span="4" @click="goWaringInfo(item.id,index)">{{item.type}}</van-col>
						<van-col span="3" @click="goBbs(item.id,index,item.bbs_info.id)">{{item.is_read==0?'未查看':'已查看'}}</van-col>
					</van-row>
					<div class="result_bbsbox" @click="goBbs(item.id,index,item.bbs_info.id)">
						<div class="result_bbstit">{{item.bbs_info.name}}
							<img class="result_title_bage" v-if="item.bbs_info.label_two.type==2" :src="img.new">
							<img class="result_title_bage" v-if="item.bbs_info.label.type==1&&item.bbs_info.label.name=='1级'" :src="img.level1">
							<img class="result_title_bage" v-if="item.bbs_info.label.type==1&&item.bbs_info.label.name=='2级'" :src="img.level2">
							<img class="result_title_bage" v-if="item.bbs_info.label.type==1&&item.bbs_info.label.name=='3级'" :src="img.level3">
							<img class="result_title_bage" v-if="item.bbs_info.label.type==3" :src="img.hot">
							<img class="result_title_bage" v-if="item.bbs_info.label.type==4" :src="img.vie">
						</div>
						<div class="result_bbstime">
							<div style="flex: 1;">{{item.bbs_info.post_time}}</div>
							<div class="f-r">
								<span>阅读{{item.bbs_info.read_num}}</span>
								<span style="margin-left: 20px;">评论{{item.bbs_info.comment_num}}</span>
							</div>
						</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
	<div class="no_list" v-else>没有预警消息</div>
</div>
</template>
<script>
	import admin from '../../api/admin';
	import { mapState } from 'vuex';
	import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon,List,PullRefresh } from 'vant';
	export default {
		data () {
			return {
				message:'',
				text:'',
				list:[],
				no_list:false,
				params:{
					page:1,
					size:20
				},
				loading: false,
				finished: false,
				isLoading:false,
				img:{
					hot:require('../../assets/img/hot.png'),
					new: require('../../assets/img/new.png'),
					level1: require('../../assets/img/level1.png'),
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user
			})
		},
		
		created () {
		},
		methods: {
			
			goWaringInfo(id,index) {
				var params={
					id:id
				}
				admin.readMessage(params).then(res => {
					if(res.data.state==1){
						var list=this.list
						list[index].is_read=1
						this.list=list
					}else{

					}

				})
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordwarning/'+id})
				// this.$router.push({name:'KeywordWarning',params:{id:id}});
			},
			goBbs(id,index,bbsid){
				var params={
					id:id
				}
				admin.readMessage(params).then(res => {
					if(res.data.state==1){
						var list=this.list
						list[index].is_read=1
						this.list=list
					}else{

					}

				})
				localStorage.setItem('bbsid', bbsid)
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=bbsinfo'})
			},
			onRefresh() {
				this.isLoading = false;
				this.finished = false
				this.list=[]
				this.params.page = 1
				this.onLoad()
			},
			onLoad(){
				setTimeout(() => {
					
					admin.getMessage(this.params).then(res => {
						if(res.data.state==1){
							this.list.push.apply(this.list, res.data.data)
							this.params.page += 1
							this.loading = false
							if(res.data.data.length <10){
								this.finished = true
							}
							var list=res.data.data
							if(list.length==0){
								this.no_list=true
							}
						}else{

						}

					})
					
				}, 500);
			}


		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Search.name]:Search,
			[Cell.name]:Cell,
			[Toast.name]:Toast,
			[DatetimePicker.name]:DatetimePicker,
			[Field.name]:Field,
			[Popup.name]:Popup,
			[Button.name]:Button,
			[Icon.name]:Icon,
			[PullRefresh.name]:PullRefresh,
			[List.name]: List,
		}
	}
</script>
<style lang="scss">
.searchresult{
	padding: 15px;
	.result_title{
		font-size: 14px;
		margin-top: 15px;
		padding-bottom:10px;
		border-bottom: 1px solid #EEEEEE;
		.red_border{
			border:1px solid #E02020;
			color: #E02020;
			font-size: 10px;
			border-radius:4px;
			padding:3px 10px;
			margin-left: 5px;
		}
		.van-button{
			height: auto;
			color:#FFFFFF;
			font-size: 10px;
			border-radius:4px;
			padding:3px 10px;
			margin-left: 5px;
			background-color:#333333;
		}
	}
	.search_resu{
		// margin-top: 20px;
		.c-gray{
			color: #999999;
		}
		.result_box{
			font-size: 12px;
			padding:10px;
			margin-top: 15px;
			border:1px solid #BBBBBB;
			border-radius:4px;
			.van-col{
				text-align: center;
			}
			.result_box_title{
				display: flex;
				align-items:center;
				border-bottom:1px solid #EEEEEE;
				padding:0 10px 10px 10px;
				margin-bottom: 10px;
			}
			.result_text{
				display: flex;
				align-items:center;
				padding:10px 10px;
			}
			.result_text_active{
				background-color:#F8F8F8;
			}
			.result_left{
				flex: 1;
			}
			.result_right{
				float: right;
			}
			.result_bbstit{
				font-size: 12px;
				text-decoration:underline;
				border-bottom:1px solid #EEEEEE;
				padding-bottom:10px;
			}
			.result_title_bage{
				width: 36px;
				height: 16px;
				vertical-align:middle;
				margin-left: 10px;
			}
			.result_bbstime{
				color: #999999;
				font-size: 12px;
				padding-top:10px;
				display: flex;
				align-items:center;
			}
			.result_bbsbox{
				font-size: 12px;
				padding:5px;
				margin-top: 15px;
				border-radius:4px;	
				background-color:#F8F8F8;
				.result_bbstit{
					font-size: 12px;
					text-decoration:underline;
					border-bottom:1px solid #EEEEEE;
					padding-bottom:10px;
				}
				.result_title_bage{
					width: 36px;
					height: 16px;
					vertical-align:middle;
					margin-left: 10px;
				}
				.result_bbstime{
					color: #999999;
					font-size: 12px;
					padding-top:10px;
					display: flex;
					align-items:center;
				}
			}
		}
		.keyword_box{
			border: 1px solid #BBBBBB;
			border-radius: 4px;
			font-size:12px;
		}
	}
	.no_list{
		text-align: center;
		margin-top: 80px;
		color: #BBBBBB;
		font-size: 12px;
	}
}

</style>